import {VisibleDays} from './types';
import {AxiosInstance, AxiosResponse} from 'axios';

export interface IReportApi {
    downloadTimeReportByEmployee<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, searchQuery?: string): Promise<AxiosResponse<T>>;
    downloadTimeReportByProject<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, searchQuery?: string): Promise<AxiosResponse<T>>;
    downloadTimeReportByEmployeeDaily<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, visibleDays?: VisibleDays, searchQuery?: string): Promise<AxiosResponse<T>>;
    downloadTimeReportByProjectDaily<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, visibleDays?: VisibleDays, searchQuery?: string): Promise<AxiosResponse<T>>;
}

export default class ReportApi implements IReportApi {
    private readonly _axiosInstance;
    private readonly _controller = 'report'

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async downloadTimeReportByEmployee<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, searchQuery?: string): Promise<AxiosResponse<T>> {
        return await this.downloadByReport<T>('time-report/by-employee', dateFrom, dateTo, employeeIds, projectIds, undefined, undefined, showAbsences, searchQuery);
    }
    async downloadTimeReportByProject<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, searchQuery?: string): Promise<AxiosResponse<T>> {
        return await this.downloadByReport<T>('time-report/by-project', dateFrom, dateTo, employeeIds, projectIds, undefined, undefined, showAbsences, searchQuery);
    }
    async downloadTimeReportByEmployeeDaily<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, visibleDays?: VisibleDays, searchQuery?: string): Promise<AxiosResponse<T>> {
        return await this.downloadByReport<T>('time-report/by-employee/daily', dateFrom, dateTo, employeeIds, projectIds, undefined, visibleDays, showAbsences, searchQuery);
    }
    async downloadTimeReportByProjectDaily<T>(dateFrom: string, dateTo: string, employeeIds?: number[], projectIds?: number[], showAbsences?: boolean, visibleDays?: VisibleDays, searchQuery?: string): Promise<AxiosResponse<T>> {
        return await this.downloadByReport<T>('time-report/by-project/daily', dateFrom, dateTo, employeeIds, projectIds, undefined, visibleDays, showAbsences, searchQuery);
    }
    private async downloadByReport<Blob>(
        by: 'time-report/by-employee' | 'time-report/by-project' | 'time-report/by-employee/daily' | 'time-report/by-project/daily',
        dateFrom: string, 
        dateTo: string,
        employeeIds?: number[] | undefined, 
        projectIds?: number[] | undefined,
        hideEmptyProjects?: boolean | undefined,
        visibleDays?: VisibleDays | undefined,
        showAbsences?: boolean | undefined,
        searchQuery?: string | undefined,
    ): Promise<AxiosResponse<Blob>> {
        const employeesString = employeeIds?.map((x) => `&employeeIds=${x}`).join('') ?? '';
        const projectsString = projectIds?.map((x) => `&projectIds=${x}`).join('') ?? '';
        const hideEmptyProjectsString = hideEmptyProjects !== undefined ? hideEmptyProjects ? '&hideEmptyProjects=true' : '&hideEmptyProjects=false' : '';
        const visibleDaysString = visibleDays !== undefined ? `&visibleDays=${visibleDays}` : '';
        const showAbsencesString = showAbsences !== undefined ? showAbsences ? '&showAbsences=true' : '&showAbsences=false' : '';
        const searchQueryString = searchQuery?.trim() ? `&q=${encodeURIComponent(searchQuery.trim())}` : '';
        return await this._axiosInstance.get<Blob>(`${this._controller}/${by}/download?dateFrom=${dateFrom}&dateTo=${dateTo}${hideEmptyProjectsString}${visibleDaysString}${employeesString}${projectsString}${showAbsencesString}${searchQueryString}`, {
            responseType: 'blob',
        })

    }
}
